import React, { useState, useEffect } from "react";
import "../assets/css/Gallery.css";

import img1 from "../assets/motivation/Indrajeet sir.jpg";
import img2 from "../assets/motivation/Indrajeet sir1.jpg";
import img3 from "../assets/motivation/Indrajeet sir2.jpg";
import img4 from "../assets/motivation/Indrajeet sir3.jpg";
import img5 from "../assets/motivation/Indrajeet sir4.jpg";
import img6 from "../assets/motivation/Indrajeet sir5.jpg";


const images = [img1, img2, img3, img4, img5,img6];

const Gallery = () => {

    const [current, setCurrent] = useState(2);

    const nextSlide = () => {
        setCurrent((prev) => (prev + 1) % images.length);
    };

    const prevSlide = () => {
        setCurrent((prev) =>
            prev === 0 ? images.length - 1 : prev - 1
        );
    };

    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 4000);

        return () => clearInterval(interval);
    }, []);

    const getIndex = (index) => {
        return (index + images.length) % images.length;
    };

    return (

        <section className="gallery-section">

            {/* <h2 className="gallery-title">Gallery</h2> */}

            <div className="gallery-container">

                <button className="nav prev" onClick={prevSlide}>
                    ‹
                </button>

                <div className="gallery-track">

                    {images.map((img, index) => {

                        let position = index - current;

                        if (position < -2) position += images.length;
                        if (position > 2) position -= images.length;

                        return (
                            <div
                                key={index}
                                className={`gallery-item pos-${position}`}
                            >
                                <img src={img} alt="gallery" />
                            </div>
                        );
                    })}

                </div>

                <button className="nav next" onClick={nextSlide}>
                    ›
                </button>

            </div>

        </section>

    );
};

export default Gallery;